module.exports = __webpack_public_path__ + "static/media/fourth-screen.b0f06f67.svg";